import { Vector2, Vector3 } from 'three';

const scaleRatio = 0.001; // Ratio to scale dimensions by. 1.0 means no scaling. 0.01 is 1:100 scale.

export const sceneUnitsFromMm = (value: number | undefined | null): number => (value ?? 0.0) * scaleRatio;

export const mmFromSceneUnits = (value: number | undefined | null): number => (value ?? 0.0) / scaleRatio;

export const getScaledArray = (arr: number[]): number[] => arr.map(sceneUnitsFromMm);

export const getScaled = (vector: {x: number, y: number, z: number} ) => {
    return {x: sceneUnitsFromMm(vector.x), y: sceneUnitsFromMm(vector.y), z: sceneUnitsFromMm(vector.z)};
}

export const getScaledVector2 = (vector: {x: number, y: number} ) => {
    return new Vector2( sceneUnitsFromMm(vector.x), sceneUnitsFromMm(vector.y) );
}

export const getScaledVector3 = (vector: {x: number, y: number, z: number} ) => {
    const scaled = getScaled(vector);
    return new Vector3( scaled.x, scaled.y, scaled.z ); 
}
